import { createApp } from 'vue'
/* Bootstrap before App so App/index.css .btn-accent/.btn-ghost win the cascade.
   (Importing App first let bootstrap.css load after and washed Login/Sign up on cold refresh.) */
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "vue3-loading-skeleton/dist/style.css";

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "@/config";
import { installApiAuth } from "@/api/http";
import { initAnalytics } from "@/utils/analytics";

initializeApp(firebaseConfig);
installApiAuth();
initAnalytics();

createApp(App).use(store).use(router).mount('#app')
